import { RootPaths } from '@fcom/core/constants';

import type {
  OndMarketingLinkGroup,
  OndMarketingLinkListItem,
} from '../components/ond-marketing-link-list/ond-marketing-link-list.component';
import {
  OndLinkTranslations,
  OndMarketingRoutesPath,
  OndPairEnhanced,
} from '../interfaces/ond-marketing-offers.interface';
import { encodeIgnoredSEOTitle } from './utils';

/**
 * Splits an ordered list of links into evenly sized groups.
 */
export const splitLinksIntoGroups = (links: OndMarketingLinkListItem[], groupCount = 4): OndMarketingLinkGroup[] => {
  const base = Math.floor(links.length / groupCount);
  const remainder = links.length % groupCount;
  const groups: OndMarketingLinkGroup[] = [];

  let start = 0;
  for (let i = 0; i < groupCount && start < links.length; i++) {
    const end = start + base + (i < remainder ? 1 : 0);
    groups.push({ links: links.slice(start, end) });
    start = end;
  }

  return groups;
};

export const createFromCityLink = (
  language: string,
  city: string,
  linkTranslations: OndLinkTranslations,
  ondPair: Pick<OndPairEnhanced, 'originCityName'>
): string => {
  return `
  /${language}
  /${RootPaths.OND_MARKETING_LANDING_ROOT}
  /${OndMarketingRoutesPath.FROM}
  /${city.toLowerCase()}
  /${encodeIgnoredSEOTitle(linkTranslations.from.replace('{origin}', ondPair.originCityName))}
  `.replace(/\s/g, '');
};

export const createFromCountryLink = (
  language: string,
  country: string,
  countryName: string,
  linkTranslations: OndLinkTranslations
): string => {
  return `
  /${language}
  /${RootPaths.OND_MARKETING_LANDING_ROOT}
  /${OndMarketingRoutesPath.FROM_COUNTRY}
  /${country}
  /${encodeIgnoredSEOTitle(linkTranslations.from.replace('{origin}', countryName))}
  `.replace(/\s/g, '');
};

export const createCityToCityLink = (
  language: string,
  origin: string,
  destination: string,
  linkTranslations: OndLinkTranslations,
  pair: OndPairEnhanced
): string => {
  return `
  /${language}
  /${RootPaths.OND_MARKETING_LANDING_ROOT}
  /${OndMarketingRoutesPath.CITY_TO_CITY}
  /${origin.toLowerCase()}
  /${destination.toLowerCase()}
  /${encodeIgnoredSEOTitle(
    linkTranslations.fromTo.replace('{origin}', pair.originCityName).replace('{destination}', pair.destinationCityName)
  )}
  `.replace(/\s/g, '');
};

export const createCountryToCountryLink = (
  language: string,
  origin: string,
  destination: string,
  linkTranslations: OndLinkTranslations,
  pair: Pick<OndPairEnhanced, 'originCountryName' | 'destinationCountryName'>
): string => {
  return `
  /${language}
  /${RootPaths.OND_MARKETING_LANDING_ROOT}
  /${OndMarketingRoutesPath.COUNTRY_TO_COUNTRY}
  /${origin}
  /${destination}
  /${encodeIgnoredSEOTitle(
    linkTranslations.fromTo
      .replace('{origin}', pair.originCountryName)
      .replace('{destination}', pair.destinationCountryName)
  )}
  `.replace(/\s/g, '');
};
